import { render, staticRenderFns } from "./StudyPlan.vue?vue&type=template&id=fdad2f00"
import script from "./StudyPlan.vue?vue&type=script&lang=js"
export * from "./StudyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports